import API from 'services/api';

export const saveAirbnbInvoice = ({
  calculationId,
  file,
  invoiceNumber,
  invoiceDate,
  amount,
  currencyCode,
  description,
}: {
  calculationId: string;
  file: File;
  invoiceNumber: string;
  invoiceDate: string;
  amount: number;
  currencyCode: string;
  description: string;
}) => {
  const formData = new FormData();
  formData.append('InvoiceNumber', invoiceNumber);
  formData.append('InvoiceDate', invoiceDate);
  formData.append('Amount', String(amount));
  formData.append('CurrencyCode', currencyCode);
  formData.append('Description', description);
  formData.append('File', file);

  return API.post(`api/accommodation/calculations/${calculationId}/airbnbInvoice`, formData, {
    headers: { 'Content-Type': 'multipart/form-data;' },
  });
};
